const PurchaseFlow = () => import(/* webpackChunkName: "purchaseFlow" */ './PurchaseFlow.vue')

const index = {
  path: 'purchase/flow',
  name: 'Purchase Flow',
  component: PurchaseFlow,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
